export const forBusiness_beauty_perfect = [
	{
		icon: '🧴',
		title: 'perfectData_title1',
		subtitle: 'perfectData_subtitle1',
	},
	{
		icon: '🛍️',
		title: 'perfectData_title2',
		subtitle: 'perfectData_subtitle2',
	},
	{
		icon: '👩‍💻',
		title: 'perfectData_title3',
		subtitle: 'perfectData_subtitle3',
	},
	{
		icon: '📢',
		title: 'perfectData_title4',
		subtitle: 'perfectData_subtitle4',
	},
	{
		icon: '👩‍🎤',
		title: 'perfectData_title5',
		subtitle: 'perfectData_subtitle5',
	},
];
